import {
  Anchor,
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Input,
  Select,
} from "@mantine/core";
import { IconMail, IconPencil } from "@tabler/icons-react";
import { useEffect, useState } from "react";

import { orpcClient } from "@/lib/orpc-client";
import { single } from "@/lib/orpc-batch";
import { useData } from "@/utility/state/contextAPI";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

function AddInventoryDoneListPage() {
  const { t } = useTranslation();
  const [currentStage, setCurrentStage] = useState(0);
  const [inventoryDoneData, setInventoryDoneData] = useState({
    company: localStorage.getItem("companyId"),
    name: "",
    remarks: "",
    deliveryPerson: "",
    licensePlateNumber: "",
    warehouseStaffId: null,
  });
  const [employeeData, setEmployeeData] = useState([]);
  const [tempProductData, setTempProductData] = useState([]);
  const [tempProductInput, setTempProductInput] = useState([]);
  const [tempWarehouseData, setTempWarehouseData] = useState([]);
  const [tempWarehouseInput, setTempWarehouseInput] = useState([]);
  const [tempStorageLocationInput, setTempStorageLocationInput] = useState([]);
  const [tempAmount, setTempAmount] = useState([]);
  const {
    modal: { contextOpenModal, contextCloseModal, contextSetModalContent },
  } = useData();
  const [tempProductList, setTempProductList] = useState([]);
  const navigate = useNavigate();

  const handleSubmit = async (inventoryDoneData, tempProductList) => {
    if (tempProductList?.length <= 0) {
      console.error("商品清單最少要有一列");
      return;
    }

    const hasInvalidItems = tempProductList.some(
      (item) => !item?.product?.id || !item?.storageLocation || !item?.amount
    );

    if (hasInvalidItems) {
      console.error("請確保每個商品都選擇了產品、儲位和數量");
      return;
    }

    try {
      const { company, ...stockReceiptData } = inventoryDoneData;
      if (!stockReceiptData.warehouseStaffId) {
        stockReceiptData.warehouseStaffId = null;
      }
      const result = await single(
        orpcClient.stockReceipt.create([stockReceiptData])
      );
      if (result?.id) {
        const batchResults = await orpcClient.stockReceiptProduct.create(
          tempProductList.map((data) => ({
            amount: data?.amount,
            productId: data?.product?.id || null,
            storageLocationId: data?.storageLocation || null,
            stockReceiptId: result?.id,
          }))
        );
        const allSuccessful = batchResults.every((res) => res.success);
        if (allSuccessful) {
          setCurrentStage(1);
        } else {
          console.warn("Some batch operations failed:", batchResults);
        }
      }
    } catch (error) {
      console.error("Create stock receipt error", error);
      return;
    }
  };

  const handleDataChange = (name, value) => {
    setInventoryDoneData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleDeleteProductList = (index) => {
    const updatedProductList = [...tempProductList];

    updatedProductList.splice(index, 1);

    setTempProductInput((prevInputs) => {
      const updatedInputs = [...prevInputs];
      updatedInputs.splice(index, 1);
      return updatedInputs;
    });

    setTempWarehouseInput((prevInputs) => {
      const updatedInputs = [...prevInputs];
      updatedInputs.splice(index, 1);
      return updatedInputs;
    });

    setTempStorageLocationInput((prevInputs) => {
      const updatedInputs = [...prevInputs];
      updatedInputs.splice(index, 1);
      return updatedInputs;
    });

    setTempAmount((prevInputs) => {
      const updatedInputs = [...prevInputs];
      updatedInputs.splice(index, 1);
      return updatedInputs;
    });

    setTempProductList(updatedProductList);
  };

  const handleAddProductList = () => {
    setTempProductList((prev) => [...prev, []]);
  };

  const handleDisplaySelectMembers = (data) => {
    return data?.map((t) => ({ value: t?.id, label: t?.name }));
  };
  const handleDisplaySelectWarehouse = (data) => {
    return data?.map((t) => {
      return `倉庫： ${t?.name},  ID: ${t?.id}`;
    });
  };
  const handleDisplaySelectStorageLocation = (
    warehouseInput,
    warehouseData
  ) => {
    if (!warehouseInput) return;

    let match = warehouseInput?.match(/ID:\s*(\d+)/);
    let idNumber = match ? match[1] : null;

    let selectedData = warehouseData.filter((e) => e?.id == idNumber)[0];

    if (selectedData?.storageLocations) {
      return selectedData?.storageLocations.map(
        (location) =>
          `儲位： ${location?.name}    , ID: ${location?.documentId}`
      );
    } else {
      return;
    }
  };

  const handleChangeWarehouseStaff = (value, employeeData) => {
    let match = value.match(/ID:\s*(\d+)/);
    let idNumber = match ? match[1] : null;

    let selectedData = employeeData.filter((e) => e?.id == idNumber)[0];

    handleDataChange("warehouseStaffId", selectedData.id);
  };

  const handleOnChangeData = async (value, field) => {
    //let result = await apiUserGetProducts(field, value);
    //setTempProductData(result?.data);
  };

  const handleOnOptionSubmit = (type, e, data, index) => {
    let selectedData;
    if (type === "product") {
      selectedData = data.filter((item) => item?.name === e)[0];
      setTempProductList((prev) => {
        const updatedList = [...prev];
        updatedList[index] = { ...updatedList[index], [type]: selectedData };
        return updatedList;
      });
    } else {
      let idBehindMatch = e.match(/ID:\s*([a-zA-Z0-9-]+)/);
      let documentID = idBehindMatch ? idBehindMatch[1].trim() : null;

      setTempProductList((prev) => {
        const updatedList = [...prev];
        updatedList[index] = {
          ...updatedList[index],
          storageLocation: documentID,
        };
        return updatedList;
      });
    }
  };

  const {
    // company,
    name,
    remarks,
    deliveryPerson,
    licensePlateNumber,
    warehouseStaffId,
    // contact,
    // storage_locations,
  } = inventoryDoneData;

  useEffect(() => {
    const fetchData = async () => {
      try {
        let result = await apiUserGetCompany({
          id: localStorage.getItem("companyId"),
        });
        setEmployeeData(result?.data?.employees);
      } catch (error) {
        console.error("Error fetching employee data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        let result = await apiUserGetProducts();

        setTempProductData(result?.data);
      } catch (error) {
        console.error("Error fetching apiUserGetProducts data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        let result = await apiUserGetWarehouses();

        setTempWarehouseData(result?.data);
      } catch (error) {
        console.error("Error fetching apiUserGetProducts data:", error);
      }
    };

    fetchData();
  }, []);

  return currentStage === 0 ? (
    <div className="flex h-full items-center justify-center p-8">
      <div className="w-[765px] rounded-xl bg-white p-14">
        <>
          <div className="py-3 text-6xl font-bold" style={{ color: "#6F6F6F" }}>
            {t("warehouse.createStockReceipt")}
          </div>

          <div className="py-3 text-2xl font-bold" style={{ color: "#6F6F6F" }}>
            {t("warehouse.basicInfo")}
          </div>
          <div className="flex items-center justify-start">
            <div className="py-4">
              <div style={{ color: "#6F6F6F" }}>{t("warehouse.stockReceiptName")}</div>
              <Input
                value={name}
                onChange={({ target: { value } }) =>
                  handleDataChange("name", value)
                }
                placeholder="Input component"
                leftSection={<IconMail size={16} />}
              />
            </div>
          </div>
          <div className="py-3 text-2xl font-bold" style={{ color: "#6F6F6F" }}>
            {t("warehouse.productList")}
          </div>
          <div className="flex justify-center">
            <Button
              variant="default"
              style={{ maxWidth: "250px", width: "100%", margin: "1rem" }}
              radius="md"
              onClick={() => handleAddProductList(tempProductList)}
            >
              {t("warehouse.addProductRow")}
            </Button>
          </div>
          {tempProductList.map((_item, i) => {
            return (
              <div className="flex items-center justify-start">
                <div className="">
                  <div style={{ color: "#6F6F6F" }}>{t("warehouse.productName")}</div>
                  <Select
                    searchable
                    nothingFoundMessage="查無資料"
                    placeholder="Input component"
                    leftSection={<IconMail size={16} />}
                    data={handleDisplaySelectMembers(tempProductData)}
                    value={tempProductInput[i] || null}
                    onChange={(value) => {
                      setTempProductInput((prev) => {
                        const updated = [...prev];
                        updated[i] = value;
                        return updated;
                      });
                      const selectedData = tempProductData.find(
                        (p) => p?.id === value
                      );
                      setTempProductList((prev) => {
                        const updated = [...prev];
                        updated[i] = {
                          ...updated[i],
                          product: selectedData,
                        };
                        return updated;
                      });
                    }}
                  />
                </div>

                <div className=" pl-2">
                  <div style={{ color: "#6F6F6F" }}>{t("warehouse.warehouseLabel")}</div>
                  <Autocomplete
                    placeholder="Input component"
                    leftSection={<IconMail size={16} />}
                    data={handleDisplaySelectWarehouse(tempWarehouseData)}
                    value={tempWarehouseInput[i] || ""}
                    onChange={(value) => {
                      setTempWarehouseInput((prev) => {
                        const updated = [...prev];
                        updated[i] = value;
                        return updated;
                      });

                      setTempStorageLocationInput((prev) => {
                        const updated = [...prev];
                        updated[i] = [];
                        return updated;
                      });
                    }}
                  />
                </div>

                <div className=" pl-2">
                  <div style={{ color: "#6F6F6F" }}>{t("warehouse.storageLocationLabel")}</div>
                  <Autocomplete
                    placeholder="Input component"
                    leftSection={<IconMail size={16} />}
                    data={handleDisplaySelectStorageLocation(
                      tempWarehouseInput[i],
                      tempWarehouseData
                    )}
                    value={tempStorageLocationInput[i] || ""}
                    onChange={(value) =>
                      setTempStorageLocationInput((prev) => {
                        const updated = [...prev];
                        updated[i] = value;
                        return updated;
                      })
                    }
                    onOptionSubmit={(e) => {
                      handleOnOptionSubmit(
                        "warehouse",
                        e,
                        tempWarehouseData,
                        i
                      );
                    }}
                  />
                </div>
                <div className=" pl-2">
                  <div style={{ color: "#6F6F6F" }}>{t("warehouse.quantity")}</div>
                  <Input
                    placeholder="Input component"
                    leftSection={<IconMail size={16} />}
                    value={tempAmount[i] || ""}
                    onChange={(e) => {
                      setTempProductList((prev) => {
                        const updatedList = [...prev];
                        updatedList[i] = {
                          ...updatedList[i],
                          amount: e.target.value,
                        };
                        return updatedList;
                      });

                      setTempAmount((prev) => {
                        const updated = [...prev];
                        updated[i] = e.target.value;
                        return updated;
                      });
                    }}
                  />
                </div>
                <Button
                  variant="filled"
                  color="red"
                  style={{ width: "100%", maxWidth: "100px", margin: "1rem" }}
                  radius="md"
                  onClick={() => handleDeleteProductList(i)}
                >
                  {t("warehouse.deleteBtn")}
                </Button>
              </div>
            );
          })}

          <div className="py-3 text-2xl font-bold" style={{ color: "#6F6F6F" }}>
            {t("warehouse.deliveryInfo")}
          </div>

          <div className="py-4">
            <div className="flex items-center justify-start">
              <div className="">
                <div style={{ color: "#6F6F6F" }}>{t("warehouse.deliveryPerson")}</div>
                <Input
                  placeholder="Input component"
                  leftSection={<IconMail size={16} />}
                  value={deliveryPerson}
                  onChange={(e) =>
                    handleDataChange("deliveryPerson", e.target.value)
                  }
                />
              </div>
              <div className=" pl-2">
                <div style={{ color: "#6F6F6F" }}>
                  {t("warehouse.licensePlateNumber") || "送貨車牌"}
                </div>
                <Input
                  placeholder="Input component"
                  leftSection={<IconMail size={16} />}
                  value={licensePlateNumber ?? ""}
                  onChange={(e) =>
                    handleDataChange("licensePlateNumber", e.target.value)
                  }
                />
              </div>
              <div className=" pl-2">
                <div style={{ color: "#6F6F6F" }}>{t("warehouse.inboundStaff")}</div>
                <Autocomplete
                  placeholder="Input component"
                  leftSection={<IconMail size={16} />}
                  data={employeeData?.map((t) => t?.name + ` (ID: ${t?.id})`)}
                  onChange={(e) => handleChangeWarehouseStaff(e, employeeData)}
                />
              </div>
            </div>
            <div className="py-4">
              <div style={{ color: "#6F6F6F" }}>{t("warehouse.remarks")}</div>
              <Input
                placeholder="Input component"
                leftSection={<IconMail size={16} />}
                value={remarks}
                onChange={(e) => handleDataChange("remarks", e.target.value)}
              />
            </div>
          </div>

          <div className="flex">
            <Button
              variant="default"
              style={{ width: "100%", margin: "1rem" }}
              radius="md"
              onClick={() => navigate(`/hrMainPage/inventoryDone`)}
            >
              {t("warehouse.cancel")}
            </Button>

            <Button
              variant="filled"
              color="gray"
              style={{ width: "100%", margin: "1rem" }}
              radius="md"
              disabled={!tempProductList?.length}
              onClick={() => handleSubmit(inventoryDoneData, tempProductList)}
            >
              {t("warehouse.create")}
            </Button>
          </div>
        </>
      </div>
    </div>
  ) : (
    <div className="min-h-screen flex h-full items-center justify-center p-14 text-center">
      <div className="w-[487px] rounded-xl bg-white p-8">
        <div style={{ color: "#6F6F6F" }}>{t("warehouse.stockReceiptCreatedSuccess")}</div>
        <Button
          variant="filled"
          color="gray"
          style={{ width: "100%", margin: "1rem 0" }}
          radius="md"
          onClick={() => navigate("/hrMainPage/inventoryDone")}
        >
          {t("warehouse.confirm")}
        </Button>
      </div>
    </div>
  );
}
export default AddInventoryDoneListPage;
